var Ribbon_default = {
  "ribbon": "_9hjNN",
  "ribbonText": "u-GxE",
  "imageRibbon": "-Jge3"
};
export {
  Ribbon_default as default
};
//# sourceMappingURL=Ribbon-scss.js.map
